module.exports = __webpack_public_path__ + "img/dosen_weltmeister.b5336d89.png";